module.exports = __webpack_public_path__ + "img/flag-united.03fa05a.svg";